export default "__VITE_ASSET__q_ydB_Kb__"